import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    order: 3,

    [theme.breakpoints.up('sm')]: {
      order: 2,
      flexBasis: '100%',
    }
  },
  expandable: {
    display: 'flex',
    gap: theme.spacing(3),
  },
  expandableIconSpacer: {
    paddingLeft: '82px',
  },
  expandableAccordion: {
    flex: 1,
  },

  title: {
    fontWeight: 600,
  },

  arrow: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    color: theme.palette.secondary.main,
    fontSize: 34,
    order: 2,

    [theme.breakpoints.up('sm')]: {
      order: 3,
    }
  },
}));

export const useColorStyles = makeStyles({ name: 'ActionItemColors' })(theme => ({
  colorPrimary: {
    backgroundColor: theme.palette.primary.background,
    color: theme.palette.primary.light,
  },
  colorSecondary: {
    backgroundColor: theme.palette.secondary.background,
    color: theme.palette.secondary.light,
  },
  colorDanger: {
    backgroundColor: theme.palette.error.background,
    color: theme.palette.error.main,
  },
  colorWarning: {
    backgroundColor: theme.palette.warning.background,
    color: theme.palette.warning.main,
  },
  colorInfo: {
    backgroundColor: theme.palette.info.background,
    color: theme.palette.info.main,
  },
  colorSuccess: {
    backgroundColor: theme.palette.success.background,
    color: theme.palette.success.main,
  },
  colorDefault: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.disabled,
  },
  colorOrange: {
    backgroundColor: theme.palette.orange.background,
    color: theme.palette.orange.main,
  },
}));
